export default function printDocument(fileName = "report") {
    // Store the current title
    const currentTitle = document.title;
    document.title = fileName;
    window.print();
    // Restore the original title
    document.title = currentTitle;
}
